import Navtabs from "../../components/navtabs/Navtabs";
import Logo from "../../components/logo/Logo";

import "./Navbar.css";
import "./NavbarResponsive.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import CustomAnchor from "../Anchor/CustomAnchor";
import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="col-lg-2 col-6 p-0 d-flex align-items-center justify-content-md-end justify-content-start">
        <Logo />
      </div>
      <div className="col-lg-7 p-0 d-flex align-items-center justify-content-center non-mobile-navtabs">
        <Navtabs />
      </div>
      <div className="col-lg-3 p-0 non-mobile-action">
        <div className="d-flex gap-2 align-items-center justify-content-center navbar-actions-wrapper">
          <CustomAnchor
            path="/shop"
            classname="btn btn-warning d-flex align-items-center gap-2 navbar-anchor-buttons"
          >
            <span>SHOP NOW</span>
            <FontAwesomeIcon
              icon={faStore}
              className="header-anchor-icon"
            />
          </CustomAnchor>
          <CustomAnchor
            path="https://web.facebook.com/profile.php?id=100076482242670"
            classname="footer-fb-icon d-flex gap-2 align-items-center"
          >
            <FontAwesomeIcon
              icon={faFacebook}
              style={{
                fontSize: "19pt",
                color: "var(--black)",
              }}
            />
          </CustomAnchor>
          <CustomAnchor
            path="https://wa.me/c/27722480000"
            classname="footer-fb-icon d-flex gap-2 align-items-center"
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              style={{
                fontSize: "19pt",
                color: "var(--black)",
              }}
            />
          </CustomAnchor>
        </div>
      </div>
      <div className="col-6 p-0 d-flex align-items-center justify-content-end mobile-navbar">
        <a
          className="btn btn-warning"
          data-bs-toggle="offcanvas"
          href="#offcanvasExample"
          role="button"
          aria-controls="offcanvasExample"
        >
          <FontAwesomeIcon icon={faBars} className="mobile-nav-button" />
        </a>
      </div>
    </nav>
  );
}

export default Navbar;
